<script>
import { RecyclingFolder } from '@/models/recyclingModule/recyclingFolder/RecyclingFolder'
import { handleResponseError, shouldShowTooltip } from '@/components/utils/globalFunction'
import { RepairFile } from '@/models/RepairFile'
import ManufacturerService from '@/services/referentiel/ManufacturerService'
import ProductService from '@/services/ProductService'
import RecyclingReferentialService from '@/services/recyclingModule/RecyclingReferentialService'
import RecyclingFolderService from '@/services/recyclingModule/RecyclingFolderService'
import { auth as $store } from '@/store/AuthModule'
import ResponseConstant from '@/constants/responseConstant'
import SelectStoreModal from '@/components/modal/repair-file/SelectStoreModal.vue'
import Validator from '@/components/utils/validator'

export default {
  name: 'StepProductInformation',
  components: { SelectStoreModal },
  props: {
    currentStep: Number,
    currentRepairFile: {
      type: RepairFile,
      default: null
    },
    currentRecyclingFolder: {
      type: RecyclingFolder,
      default: null
    }
  },
  data() {
    return {
      dataLoaded: false,
      recyclingFolder: null,

      formProductInformationValid: false,
      loading: false,
      awaitingSearch: false,

      selectedStore: null,

      companyName: '',

      depositDate: new Date(),
      today: new Date(),
      showValidDate: false,

      searchManufacturer: '',
      selectedManufacturer: null,
      manufacturerList: [],

      searchProduct: '',
      selectedProduct: null,
      productList: [],
      selectedProductObject: null,
      productNotFound: false,

      serialNumber: null,

      productConditionList: [],
      selectedProductCondition: null,

      requiredRules: Validator.requiredRules,

      error: null
    }
  },
  async mounted() {
    const storeSelected = this.$store.getters['auth/getRepairFileStoreSelected']
    if (storeSelected !== null) {
      this.selectedStore = storeSelected
    } else {
      const storeList = this.$store.getters['auth/getStoreListCollaborator']
      if (!this.currentRepairFile) {
        if (!this.currentRecyclingFolder) {
          if (storeList.length > 1) {
            const response = await this.$refs.selectStoreModal.show({
              arrayList: storeList,
              title: this.$t('FILE_STEP_PRODUCT.STORE_MODAL.TITLE'),
              message: this.$t('FILE_STEP_PRODUCT.STORE_MODAL.MESSAGE'),
              placeHolder: this.$t('FILE_STEP_PRODUCT.STORE_MODAL.PLACEHOLDER'),
              validateButton: this.$t('COMMON.BUTTON.CONTINUE')
            })
            if (response.confirmed) {
              this.selectedStore = response.selection
              this.$store.commit('auth/setRepairFileStoreSelected', this.selectedStore)
            }
          } else {
            this.selectedStore = storeList[0]
            this.$store.commit('auth/setRepairFileStoreSelected', storeList[0])
          }
        } else {
          this.selectedStore = storeList.find(
            (store) => store.boomerang_id === this.currentRecyclingFolder.storeBoomerangId
          )
        }
      } else {
        this.selectedStore = storeList.find(
          (store) => store.boomerang_id === this.currentRepairFile.store_boomerang_id
        )
      }
    }

    await this.getManufacturerList()

    if (this.currentRepairFile) {
      this.companyName = this.currentRepairFile.company
      this.serialNumber = this.currentRepairFile.product_serial_number
      const repairFileManufacturer = this.manufacturerList.find(
        (manufacturer) =>
          manufacturer.boomerangId === this.currentRepairFile.manufacturer_boomerang_id
      )
      this.selectedManufacturer = repairFileManufacturer.technicalId

      if (this.selectedManufacturer) {
        await this.getProductList(this.selectedManufacturer)

        const repairFileProduct = this.productList.find(
          (product) => product.boomerangId === this.currentRepairFile.product_boomerang_id
        )
        if (repairFileProduct) {
          this.selectedProduct = repairFileProduct.technicalId
        }
      }
    }

    if (this.currentRecyclingFolder) {
      this.companyName = this.currentRecyclingFolder.clientCompanyName
      const repairFileManufacturer = this.manufacturerList.find(
        (manufacturer) =>
          manufacturer.boomerangId === this.currentRecyclingFolder.manufacturerBoomerangId
      )
      this.selectedManufacturer = repairFileManufacturer.technicalId

      if (this.currentRecyclingFolder.hasDefaultProduct) {
        this.productNotFound = true
        this.serialNumber = this.currentRecyclingFolder.productSerialNumber
          ? this.currentRecyclingFolder.productSerialNumber
          : ''
        this.selectedProduct = null
        this.selectedProductObject = null
      } else {
        await this.getProductList(this.selectedManufacturer)
        const recyclingFolderProduct = this.productList.find(
          (product) => product.boomerangId === this.currentRecyclingFolder.productBoomerangId
        )
        this.selectedProduct = recyclingFolderProduct.technicalId
        this.serialNumber = this.currentRecyclingFolder.productSerialNumber

        await this.getProductConditionList(recyclingFolderProduct.boomerangId)
        const productCondition = this.productConditionList.find(
          (condition) =>
            condition.technicalId ===
            parseInt(this.currentRecyclingFolder.buybackDetail.recyclingBuybackPriceId, 10)
        )

        if (productCondition) {
          this.selectedProductCondition = productCondition.technicalId
        }
      }
    }

    this.dataLoaded = true
  },
  watch: {
    async selectedManufacturer() {
      this.selectedProduct = null
      if (this.selectedManufacturer) {
        await this.getProductList(this.selectedManufacturer)
      } else {
        this.productList = []
      }
    },
    async selectedProduct() {
      if (this.selectedProduct) {
        const product = this.getProductById(this.selectedProduct)
        await this.getProductDetail(product.boomerangId)
        await this.getProductConditionList(product.boomerangId)
      } else {
        this.selectedProduct = null
        this.selectedProductObject = null
        this.productConditionList = []
        this.selectedProductCondition = null
        this.$refs.formProductInformation.validate()
      }
    },
    productNotFound() {
      if (this.productNotFound === true) {
        this.serialNumber = null
        this.selectedProduct = null
        this.selectedProductObject = null
        this.productConditionList = []
        this.selectedProductCondition = null
        this.$refs.formProductInformation.validate()
      } else {
        this.serialNumber =
          this.currentRecyclingFolder && this.currentRecyclingFolder.productSerialNumber
            ? this.currentRecyclingFolder.productSerialNumber
            : ''
      }
    }
  },
  computed: {
    filteredManufacturerList() {
      if (this.searchManufacturer === null || this.searchManufacturer.length < 2) {
        return []
      }
      return this.manufacturerList.filter((manufacturer) =>
        manufacturer.name.toLowerCase().includes(this.searchManufacturer.toLowerCase())
      )
    },
    filteredProductList() {
      if (this.searchProduct === null || this.searchProduct.length < 2) {
        return []
      }
      return this.productList.filter((product) =>
        product.boomerangName.toLowerCase().includes(this.searchProduct.toLowerCase())
      )
    }
  },
  methods: {
    shouldShowTooltip,
    async submit() {
      if (this.$refs.formProductInformation.validate()) {
        const manufacturerObject = this.getManufacturerById(this.selectedManufacturer)

        this.error = null
        this.loading = true
        try {
          const year = this.depositDate.getFullYear()
          const month = (this.depositDate.getMonth() + 1).toString().padStart(2, '0')
          const day = this.depositDate.getDate().toString().padStart(2, '0')

          if (this.productNotFound) {
            const data = {
              company: this.companyName,
              depositDate: `${year}-${month}-${day}`,
              manufacturerBoomerangId: manufacturerObject.boomerangId,
              repairFileBoomerangId: this.currentRepairFile
                ? this.currentRepairFile.boomerang_id
                : null,
              requesterCollaboratorId: $store.state.currentCollaborator.technical_id,
              networkTechnicalId: this.selectedStore.network.technical_id,
              storeTechnicalId: this.selectedStore.technical_id
            }

            let response = null
            if (this.currentRecyclingFolder) {
              response =
                await RecyclingFolderService.updateRecyclingFolderProductInformationWithoutProduct(
                  this.currentRecyclingFolder.boomerangId,
                  data
                )
              this.$emit('change-step', this.currentStep + 1)
            } else {
              response = await RecyclingFolderService.createRecyclingFolderWithoutProduct(data)
              this.$router.push('/recycling-module/create-folder-page/' + response.boomerangId)
            }
          } else {
            const data = {
              company: this.companyName,
              depositDate: `${year}-${month}-${day}`,
              manufacturerBoomerangId: manufacturerObject.boomerangId,
              productBoomerangId: this.selectedProductObject.boomerangId,
              serialNumber: this.serialNumber,
              productConditionTechnicalId: this.selectedProductCondition,
              repairFileBoomerangId: this.currentRepairFile
                ? this.currentRepairFile.boomerang_id
                : null,
              requesterCollaboratorId: $store.state.currentCollaborator.technical_id,
              networkTechnicalId: this.selectedStore.network.technical_id,
              storeTechnicalId: this.selectedStore.technical_id
            }

            let response = null
            if (this.currentRecyclingFolder) {
              response = await RecyclingFolderService.updateRecyclingFolderProductInformation(
                this.currentRecyclingFolder.boomerangId,
                data
              )
              this.$emit('change-step', this.currentStep + 1)
            } else {
              response = await RecyclingFolderService.createRecyclingFolder(data)
              this.$router.push('/recycling-module/create-folder-page/' + response.boomerangId)
            }
          }
        } catch (error) {
          handleResponseError(error)
          if (error.response?.data && error.response.data.key in ResponseConstant) {
            this.setError(error.response.data.key)
          }
        } finally {
          this.loading = false
        }
      }
    },
    setError(key) {
      switch (key) {
        case 'invalid_company_name_error_key':
          this.error = { companyName: this.$t('ERROR.' + ResponseConstant[key]) }
          break
        case 'invalid_deposit_date_error_key':
          this.error = { depositDate: this.$t('ERROR.' + ResponseConstant[key]) }
          break
        case 'invalid_serial_number_error_key':
          this.error = { serialNumber: this.$t('ERROR.' + ResponseConstant[key]) }
          break
        default:
          this.error = ''
      }
    },
    formatDate() {
      const date = this.depositDate
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    async getManufacturerList() {
      this.loading = true
      try {
        const response = await ManufacturerService.getManufacturerList()
        this.manufacturerList = response.itemList
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    getManufacturerById(id) {
      return this.manufacturerList.find((manufacturer) => manufacturer.technicalId === id)
    },
    async getProductList(selectedManufacturerTechnicalId) {
      const manufacturer = this.getManufacturerById(selectedManufacturerTechnicalId)

      this.loading = true
      try {
        const response = await RecyclingReferentialService.getAllProductByManufacturer(
          manufacturer.boomerangId
        )
        this.productList = response.itemList
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    getProductById(id) {
      return this.productList.find((product) => product.technicalId === id)
    },
    async getProductDetail(productBoomerangId) {
      this.loading = true
      try {
        this.selectedProductObject = await ProductService.getProduct(productBoomerangId)
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async getProductConditionList(productBoomerangId) {
      this.loading = true
      try {
        const response = await RecyclingReferentialService.getProductConditionList(
          productBoomerangId
        )
        this.productConditionList = response.itemList
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-row v-if="dataLoaded" class="step-container">
    <v-col cols="7">
      <v-card class="step-card rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
        <v-form
          ref="formProductInformation"
          v-model="formProductInformationValid"
          @submit.prevent="submit"
        >
          <!--Part Top Product Information-->
          <v-row>
            <v-col cols="12">
              <h1>{{ $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.TITLE') }}</h1>
            </v-col>

            <!--COMPANY_NAME-->
            <v-col cols="12">
              <p required-input="true" class="content-title">
                {{ $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.LABEL.COMPANY_NAME') }}
              </p>
              <v-text-field
                v-model="companyName"
                :placeholder="
                  $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.PLACEHOLDER.COMPANY_NAME')
                "
                :rules="requiredRules"
                :error-messages="error?.companyName"
                required
              />
            </v-col>

            <!--DEPOSIT DATE-->
            <v-col cols="12">
              <p required-input="true" class="content-title">
                {{ $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.LABEL.DEPOSIT_DATE') }}
              </p>
              <div class="d-flex align-center">
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      alt="export"
                      class="date-picker"
                      src="@/assets/icons/repair-file-list/date.svg"
                      @click="showValidDate = true"
                    />
                    <v-text-field
                      v-bind="props"
                      class="ml-3 date-creation"
                      v-model="depositDate"
                      :value="formatDate()"
                      readonly
                      hide-details
                      @click="showValidDate = true"
                      :error-messages="error?.depositDate"
                    />
                    <v-icon
                      icon="mdi-check-circle-outline"
                      color="#767676"
                      class="update-icon"
                      v-if="showValidDate"
                      @click="showValidDate = false"
                    />
                  </template>
                  <v-locale-provider locale="fr">
                    <v-date-picker
                      v-model="depositDate"
                      hide-header
                      color="#559A1B"
                      locale="fr"
                      :min="today"
                      :max="today"
                      @focusin="showValidDate = true"
                      disabled
                    />
                  </v-locale-provider>
                </v-menu>
              </div>
            </v-col>

            <!-- MANUFACTURER -->
            <v-col cols="12">
              <p required-input="true" class="content-title">
                {{ $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.LABEL.MANUFACTURER') }}
              </p>
              <v-autocomplete
                id="select-manufacturer"
                class="hidden-autocomplete-arrow"
                v-model="selectedManufacturer"
                v-model:search="searchManufacturer"
                :items="filteredManufacturerList"
                :rules="requiredRules"
                :no-data-text="$t('COMMON.NO_DATA')"
                :placeholder="
                  $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.PLACEHOLDER.MANUFACTURER')
                "
                clearable
                hide-details
                item-title="name"
                item-value="technicalId"
                :disabled="selectedProduct"
                hide-no-data
                no-filter
              >
                <template v-slot:selection="{ item }">
                  <v-chip v-if="getManufacturerById(item.value)" size="small">
                    <span>{{ getManufacturerById(item.value).name }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item, props }">
                  <v-list-item :title="item.title" :value="item.value" v-bind="props">
                    <v-tooltip
                      v-if="shouldShowTooltip(item, 'select-manufacturer')"
                      activator="parent"
                      location="bottom left"
                    >
                      {{ item.title }}
                    </v-tooltip>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- PRODUCT -->
            <v-col cols="12">
              <p required-input="true" class="content-title">
                {{ $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.LABEL.PRODUCT') }}
              </p>
              <v-autocomplete
                v-if="!productNotFound"
                id="select-product"
                class="hidden-autocomplete-arrow"
                v-model="selectedProduct"
                v-model:search="searchProduct"
                :items="filteredProductList"
                :rules="requiredRules"
                :no-data-text="$t('COMMON.NO_DATA')"
                :placeholder="
                  $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.PLACEHOLDER.PRODUCT')
                "
                clearable
                hide-details
                item-title="boomerangName"
                item-value="technicalId"
                :disabled="!selectedManufacturer"
                hide-no-data
                no-filter
              >
                <template v-slot:selection="{ item }">
                  <v-chip v-if="getProductById(item.value)" size="small">
                    <span>{{ getProductById(item.value).boomerangName }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item, props }">
                  <v-list-item :title="item.title" :value="item.value" v-bind="props">
                    <v-tooltip
                      v-if="shouldShowTooltip(item, 'select-product')"
                      activator="parent"
                      location="bottom left"
                    >
                      {{ item.title }}
                    </v-tooltip>
                  </v-list-item>
                </template>
              </v-autocomplete>

              <v-checkbox
                v-model="productNotFound"
                :label="
                  $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.LABEL.PRODUCT_NOT_FOUND')
                "
                color="#559a1b"
                hide-details
              />
              <p v-if="productNotFound" class="product-not-found-message-container">
                <span>
                  {{
                    $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.LABEL.ADD_PRODUCT_MESSAGE')
                  }}
                </span>
              </p>
            </v-col>

            <!-- SERIAL NUMBER -->
            <v-col cols="12" v-if="!productNotFound">
              <p required-input="true" class="content-title">
                {{ $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.LABEL.SERIAL_NUMBER') }}
              </p>
              <v-text-field
                v-model="serialNumber"
                :placeholder="
                  $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.FORM.PLACEHOLDER.SERIAL_NUMBER')
                "
                :rules="requiredRules"
                :error-messages="error?.serialNumber"
                required
              />
            </v-col>
          </v-row>

          <!--Part down Product Condition-->
          <v-row v-if="productConditionList.length > 0 && !productNotFound">
            <v-col cols="12">
              <h2>{{ $t('RECYCLING_MODULE.STEP_PRODUCT_INFORMATION.TITLE_CONDITION') }}</h2>
            </v-col>

            <v-radio-group v-model="selectedProductCondition" :rules="requiredRules">
              <v-col
                cols="12"
                v-for="(productCondition, index) in productConditionList"
                :key="index"
              >
                <v-row
                  class="condition-row"
                  :class="{
                    'selected-condition': selectedProductCondition === productCondition.technicalId
                  }"
                >
                  <v-col cols="1">
                    <v-radio :value="productCondition.technicalId" color="#559a1b" />
                  </v-col>
                  <v-col cols="11">
                    <p class="condition-title">
                      {{ productCondition.conditionTitle }}
                    </p>
                    <p class="condition-detail">
                      {{ productCondition.conditionDetail }}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-radio-group>
          </v-row>

          <!-- Validation form Button -->
          <v-row>
            <v-col cols="12" class="d-flex justify-start">
              <v-btn
                :disabled="!formProductInformationValid || loading"
                :loading="loading"
                class="pl-15 pr-15"
                :class="
                  !formProductInformationValid || loading
                    ? 'boom-button-transparent'
                    : 'boom-button'
                "
                type="submit"
                variant="outlined"
              >
                {{ $t('COMMON.BUTTON.CONTINUE') }}
                <img
                  alt="arrow_small-icon"
                  :class="
                    !formProductInformationValid || loading ? 'arrow-black-svg' : 'arrow-white-svg'
                  "
                  src="@/assets/icons/file/arrow_small_right.svg"
                />
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>

    <v-col cols="5">
      <v-card class="step-card rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
        <v-card
          class="product-card"
          v-if="selectedProductObject"
          :ripple="false"
          :id="selectedProductObject.technicalId"
        >
          <div class="picture" v-if="selectedProductObject.picture">
            <v-img
              class="picture-content"
              :src="selectedProductObject.picture"
              alt="Product Preview"
            />
          </div>

          <v-card-text>
            <v-row
              align="center"
              class="mx-0 flex-fill d-flex align-center justify-center flex-column"
            >
              <p class="manufacturer-name mt-5 mb-1">
                {{ getManufacturerById(selectedManufacturer).name }}
              </p>
              <p class="product-name">
                {{ selectedProductObject.boomerangName }}
              </p>
              <p class="product-name text-overflow-ellipsis">
                {{ selectedProductObject.description }}
              </p>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-col>
  </v-row>
  <SelectStoreModal ref="selectStoreModal" />
</template>

<style scoped>
.step-container {
  min-height: 70vh;

  .step-card {
    padding: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;

    .product-card {
      background-color: #efefef;
      padding: 24px;
      box-shadow: none;
      border-radius: 24px;

      .manufacturer-name {
        font-size: 18px;
        font-weight: bold;
        color: #559a1b;
      }

      .product-name {
        font-size: 18px;
        font-weight: bold;
      }

      .picture .picture-content {
        max-width: 350px;
        max-height: 350px;
      }

      .picture {
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        background: white;
        padding: 10px;
      }
    }
  }

  :deep(.v-selection-control-group) {
    display: initial;
  }

  .condition-row {
    border: solid 1px #e5e5e5;
    border-radius: 25px;
    margin: -6px 0 -6px 0;

    .condition-title {
      font-weight: bold;
    }

    .condition-detail {
      padding-left: 10px;
    }
  }

  .selected-condition {
    border: solid 1px #559a1b !important;
  }

  .content-title {
    margin-bottom: 10px;
  }

  .date-picker {
    width: 16px;
    filter: invert(48%) sepia(0%) saturate(78%) hue-rotate(135deg) brightness(95%) contrast(83%);
  }

  .date-picker,
  .date-creation {
    cursor: pointer;
  }

  .arrow-black-svg {
    height: 100%;
    width: 50%;
    filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
  }

  .arrow-white-svg {
    height: 100%;
    width: 50%;
    filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(209deg) brightness(109%) contrast(101%);
  }

  .boom-button-transparent:hover .arrow-svg {
    filter: invert(48%) sepia(35%) saturate(7492%) hue-rotate(64deg) brightness(105%) contrast(79%);
  }

  .product-not-found-message-container {
    margin-left: 40px;
    color: #7a7a7a;

    .product-not-found-message-link {
      margin-left: 2px;
      cursor: pointer;
      font-style: italic;
      text-decoration: underline;
    }
  }

  :deep(.hidden-autocomplete-arrow .v-field__append-inner) {
    display: none !important;
  }
}
</style>
